import * as _keystoresBrowser2 from "@near-js/keystores-browser";
var _keystoresBrowser = "default" in _keystoresBrowser2 ? _keystoresBrowser2.default : _keystoresBrowser2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserLocalStorageKeyStore = void 0;
var keystores_browser_1 = _keystoresBrowser;
Object.defineProperty(exports, "BrowserLocalStorageKeyStore", {
  enumerable: true,
  get: function () {
    return keystores_browser_1.BrowserLocalStorageKeyStore;
  }
});
export default exports;
export const __esModule = exports.__esModule,
  BrowserLocalStorageKeyStore = exports.BrowserLocalStorageKeyStore;